<template>
  <div class="sso justify-content-center py-5">
    <div class="sso-card d-flex bg-white border rounded overflow-hidden">
      <div v-if="!user.id" class="p-5 flex-grow-1">
        <h1>SSO</h1>
        <h4 v-if="$route.params.message" class="mb-3">
          Sign in {{ $route.params.message }}
        </h4>
        <p v-else class="text-muted">Sign in to your account</p>

        <b-form @submit.prevent="handleSubmit">
          <NanInput
            v-model="email"
            :validation="$v.email"
            prependIcon="icon-envelope"
            placeholder="Email"
            autocomplete="email"
            aria-label="Email"
            class="mb-2"
          />

          <b-btn
            :class="{ disabled: $v.$invalid }"
            variant="primary"
            type="submit"
            class="px-4"
            block
            >Log In</b-btn
          >
        </b-form>

        <b-btn to="/login" variant="link" class="mt-2">
          <i class="mr-2 icon-arrow-left-circle" />Go Back</b-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import API from "@/api";

export default {
  mixins: [validationMixin],

  metaInfo: {
    titleTemplate: "SSO - %s"
  },

  data: () => ({
    email: ""
  }),

  computed: {
    ...mapState(["user"])
  },

  watch: {
    user: {
      handler(user) {
        if (user.id) {
          const redirectPath = this.$route.query.goto
            ? decodeURIComponent(this.$route.query.goto)
            : "/dashboard";
          delete this.$route.query.goto;
          delete this.$route.query.auth;

          this.$router.replace({
            path: redirectPath,
            query: this.$route.query
          });
        }
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    if (!this.user.id && this.$route.query.auth) {
      const data = { token: { value: this.$route.query.auth } };
      this.$store.commit("user/PATCH_USER", data);
      this.$store.dispatch("user/restoreSession");
    }
  },

  methods: {
    async handleSubmit() {
      const { success, results } = await API.loginSSO(
        this.email,
        location.href
      );
      if (!success) return;

      window.open(results, "_self");
    }
  },

  validations: {
    email: { required, email }
  }
};
</script>

<style lang="scss" scoped>
.sso-card {
  max-width: 400px;
  margin: 0 auto;
}
</style>
